module.exports = __webpack_public_path__ + "img/xf_vue_index.9b8eaa38.jpg";